import { render, staticRenderFns } from "./messengers.vue?vue&type=template&id=927fbd5e&"
import script from "./messengers.vue?vue&type=script&lang=ts&"
export * from "./messengers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports